import { useMemo } from "react";
import { FilePreviewType } from "../types";
import { getFilePreviewType } from "../utils/getFilePreviewType";

export const useFilePreviewType = (
  fileUrl: string,
  fileName?: string,
  mimeType?: string,
): FilePreviewType => {
  return useMemo(
    () => getFilePreviewType(fileUrl, fileName, mimeType),
    [fileUrl, fileName, mimeType],
  );
};
